import { Loader } from '@calendly/ui/components/loader'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

import { redirectTo } from 'actions/core/navigation'
import { useSchedulingFetchEventTypesPolicyQuery } from 'features/scheduling/data/api'

const useRedirect = (path = '/app/scheduling/meeting_types/user/me') => {
  const dispatch = useDispatch()

  return () => { dispatch(redirectTo(path)) }
}

const CheckPolicy = (Component, attr, options = {}) => {
  const redirectToHome = useRedirect()
  const queryParams = useParams()
  const params = Object.fromEntries(
    Object.entries(options).map(([key, value]) => [key, queryParams[value]])
  )
  const { isFetching, data } = useSchedulingFetchEventTypesPolicyQuery(params)

  useEffect(() => {
    if (!isFetching && data && !data[attr]) {
      redirectToHome()
    }
  }, [attr, data, isFetching, redirectToHome])

  if (!attr) {
    redirectToHome()
  }

  if (!isFetching && data && data[attr]) {
    return <Component />
  }

  return <Loader />
}

export const withAllUsersAuthorization = (Component) => () => CheckPolicy(Component, 'canListUsers')

export const withAllPagesAuthorization = (Component) => () => CheckPolicy(Component, 'canListTeams')

export const withUserAuthorization = (Component) => () => CheckPolicy(Component, 'canViewUser', { user: 'user_id' })

export const withPageAuthorization = (Component) => () => CheckPolicy(Component, 'canShowTeam', { team: 'team_id' })

export const withUserGroupAuthorization = (Component) => () => CheckPolicy(Component, 'canShowUserGroup', { user_group: 'user_group_id' })
